import {
  MessageService,
  type Chat,
  type Message,
  type PutReactionInputWritable,
} from '@/shared/api';
import { useFetchComposable } from '@/shared/lib';

const useMessageReactions = () => {
  const { send: putReaction } = useFetchComposable(
    ({
      chatId,
      messageId,
      emoji,
    }: {
      chatId: Chat['id'];
      messageId: Message['id'];
      emoji: string;
    }) =>
      MessageService.putMessageReaction({
        path: { id: chatId, messageId },
        body: { emoji } satisfies PutReactionInputWritable,
      }),
  );

  const { send: deleteReaction } = useFetchComposable(
    ({ chatId, messageId }: { chatId: Chat['id']; messageId: Message['id'] }) =>
      MessageService.deleteMessageReaction({ path: { id: chatId, messageId } }),
  );

  const { send: getReactionDetails } = useFetchComposable(
    ({ chatId, messageId }: { chatId: Chat['id']; messageId: Message['id'] }) =>
      MessageService.getMessageReactions({ path: { id: chatId, messageId } }),
  );

  return { putReaction, deleteReaction, getReactionDetails };
};

export { useMessageReactions };
